import { PrefilledData } from '@/api/types';

export interface Attachment {
  formField: string;
  files: string[];
}

export const generateAttachmentsPayload = (attachmentsData: PrefilledData['attachments']): Attachment[] => {
  if (!attachmentsData) [];
  const attachments = [];

  for (const formField in attachmentsData) {
    const files = attachmentsData[formField];
    if (files && files.length > 0) {
      attachments.push({
        formField: formField,
        files: files.map((file) => file.uuid),
      });
    }
  }

  return attachments;
};
